export const NAV_RAIL_COLLAPSED_STORAGE_KEY =
  "inssa-studio.navRailCollapsed.v1";

export function toggleNavRailCollapsed(collapsed) {
  return !Boolean(collapsed);
}

export function readNavRailCollapsed(storage) {
  if (!storage) return false;

  try {
    const value = storage.getItem(NAV_RAIL_COLLAPSED_STORAGE_KEY);
    if (value === "true") return true;
    if (value === "false") return false;
    return false;
  } catch (_error) {
    return false;
  }
}

export function writeNavRailCollapsed(storage, collapsed) {
  if (!storage) return;

  try {
    storage.setItem(
      NAV_RAIL_COLLAPSED_STORAGE_KEY,
      Boolean(collapsed) ? "true" : "false",
    );
  } catch (_error) {
    // localStorage can be unavailable; expanded navigation is the safe default.
  }
}
